import { fn } from '@ember/helper';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type {
  OTBSSEntryPoint,
  OTBSSViaQPValue,
} from 'lumen/utils/constants/otb-selfservice-constants';

interface GeneralButtonsOtbSelfServiceButtonSignature {
  Args: {
    otbSelfServiceEntryPoint: OTBSSEntryPoint;
    otbSelfServiceEntryProduct: OTBSSViaQPValue;
  };
}

export default class GeneralButtonsOtbSelfServiceButton extends Component<GeneralButtonsOtbSelfServiceButtonSignature> {
  @service declare myotbSs: Services['myotb-ss'];

  <template>
    <PrismButton
      @buttonType="brand"
      @label={{t "overview_dashboard.otb_ss.empty_state.button.label"}}
      @onClick={{fn
        this.myotbSs.onOtbSelfServiceButtonClick
        @otbSelfServiceEntryProduct
        @otbSelfServiceEntryPoint
      }}
    />
  </template>
}
